<template>
  <li>
    <span>{{ $t("menu.artPool") }}</span>
    <div class="header_hover_menu">
      <router-link to="/art-pool/nft/gallery">
        {{ $t("menu.artPoolSub.viewGallery") }}
      </router-link>
      <router-link to="/art-pool/nft">
        {{ $t("menu.artPoolSub.exhibit") }}
      </router-link>
    </div>
  </li>
</template>
<script>
export default {
  name: "HeaderDropdownArtpool",
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>
